import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable, Entity } from '@shapeable/types';
import { breakpoints, theme, ColorTokens } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { EntityBubbleImage, ImageEntity, MenuItem, useLink } from '@shapeable/ui';
import { userMenuConversationsThumbnail } from '../../constants';

const cls = classNames('user-menu-items');

// -------- Types -------->

// -------- Props -------->

export type UserMenuItemsProps = Classable & HasChildren & { 
  entity?: Entity;
};

export const UserMenuItemsDefaultProps: Omit<UserMenuItemsProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});


// -------- Components -------->

const My = {
  Container: styled(MenuItem)<ContainerProps>`${ContainerStyles}`,
};

export const UserMenuItems: Shapeable.FC<UserMenuItemsProps> = (props) => {
  const { 
    className, children, entity, 
  } = props;

  const { navigate } = useLink();
  
  return (
    <My.Container 
      className={cls.name(className)}
      label='Members Chats'
      onClick={() => navigate(`/general-chat`)}
      image={<EntityBubbleImage size={32} entity={userMenuConversationsThumbnail} />}
      >
    {children}
    </My.Container>
  )
};

UserMenuItems.cls = cls;